import { render, staticRenderFns } from "./Signing.vue?vue&type=template&id=5b536f75&scoped=true"
import script from "./Signing.vue?vue&type=script&lang=js"
export * from "./Signing.vue?vue&type=script&lang=js"
import style0 from "./Signing.vue?vue&type=style&index=0&id=5b536f75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b536f75",
  null
  
)

export default component.exports